import React from "react";

import { Alert, Card, EmptyState, Pages, Points, Spinner } from "../../shared/StudioControls";

export const AudienceStep = ({ campaign, audience, audienceList, selectedDay, isBusy, onAudiencePage, onAudienceListChange }) => {
  const payload = campaign.payload;
  return (
    <Card
      labelledBy="cs-step-audience"
      title="Customer groups"
      help={["Customers are grouped by notification day", "Eligibility and notification preferences are checked again before sending"]}
    >
      <div className="cs-audience-categories" role="tablist" aria-label="Customer group view">
        <button type="button" role="tab" aria-selected={audienceList === "lead-list"} className={audienceList === "lead-list" ? "is-active" : ""} onClick={() => onAudienceListChange("lead-list")}>
          <strong>All customers</strong><span>Everyone selected for this notification set</span>
        </button>
        <button type="button" role="tab" aria-selected={audienceList === "six-day"} className={audienceList === "six-day" ? "is-active" : ""} onClick={() => onAudienceListChange("six-day", selectedDay || 1)}>
          <strong>Customers by day</strong><span>Customers grouped by notification day</span>
        </button>
      </div>
      {audienceList === "six-day" && <div className="cs-audience-days" aria-label="Notification day">
        {[1, 3, 5, 7].map(day => <button type="button" key={day} className={selectedDay === day ? "is-active" : ""} aria-pressed={selectedDay === day} onClick={() => onAudienceListChange("six-day", day)}>Day {day}</button>)}
      </div>}
      {selectedDay && <p className="cs-day-context">Day {selectedDay} send list</p>}
      <p className="cs-strong">{payload.scenario.title} · eligible customers</p>
      <Points className="cs-muted" items={selectedDay ? [
        "Eligible customers are refreshed automatically for this day.",
        "Inactive customers and customers with notifications turned off are excluded before sending."
      ] : [
        "This list combines customers recorded across all four notification send days.",
        "Open Customers by day to review each day separately."
      ]} />

      {campaign.status === "audience_building" && (
        <div className="cs-progress-panel" role="status">
          <Spinner />
          <div>
            <p className="cs-strong">Preparing eligible customers…</p>
            <p className="cs-muted">Runs in the background · sends nothing · updates automatically</p>
          </div>
        </div>
      )}

      {campaign.status === "audience_failed" && (
        <Alert tone="danger" title="Customer selection failed">
          <ul>
            <li>Retry customer selection</li>
            <li>Still failing? Ask the backend admin to check the low-priority queue and worker logs</li>
          </ul>
        </Alert>
      )}

      {payload.error && campaign.status !== "audience_failed" && <Alert tone="danger">{payload.error}</Alert>}

      {audience && (
        <React.Fragment>
          <h3 className="cs-subheading">
            {selectedDay ? `Day ${selectedDay} customers` : "All customers"} <span className="cs-muted">({Number(audience.total || 0).toLocaleString()})</span>
          </h3>
          {audience.data.length === 0 ? (
            <EmptyState
              title={selectedDay ? "No customers selected for this day yet" : "No customers selected yet"}
              description={selectedDay ? "This list fills when the notification day is processed." : "Customers appear here as notification eligibility is processed."}
            />
          ) : (
            <div className="cs-table-wrap" tabIndex={0} role="region" aria-label="Eligible customers">
              <table className="cs-table">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Language</th>
                    <th scope="col">Account</th>
                    <th scope="col">Notifications</th>
                  </tr>
                </thead>
                <tbody>
                  {audience.data.map(lead => (
                    <tr key={lead.id}>
                      <td>{lead.id}</td>
                      <td>{lead.name}</td>
                      <td>{lead.preferred_language || "English (fallback)"}</td>
                      <td>{lead.is_active ? "Active" : "Inactive"}</td>
                      <td>{lead.offer_notification ? "On" : "Off"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Pages data={audience} disabled={isBusy} onPage={onAudiencePage} label="Customer pages" />
        </React.Fragment>
      )}
    </Card>
  );
};
